<template>
  <div>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-card :loading="loading.page">
          <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
          <ul class="m-list-wrapper">
            <li>
              <a-input-search v-model="quickSearch" placeholder="Quick Search" />
            </li>
            <li>
              <a-collapse activeKey="0">
                <a-collapse-panel key="0">
                  <span slot="header">Search More...</span>
                  <div class="m-form-item-wrapper">
                    <label for="bidang">Sector</label>
                    <a-select
                      showSearch
                      allowClear
                      placeholder="Select Sector"
                      v-model="sector"
                      class="width-full"
                    >
                      <a-select-option
                        v-for="(item,index) in filtersectorlist"
                        :key="index" :value="item.bidang"
                        >{{ item.bidang }}</a-select-option
                      >
                    </a-select>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </li>
          </ul>
        </a-card>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <DataListSlot
          title="Customer List"
          :noAction="true"
          :hasExtraSlot="true"
          :dataList="datasource"
        >
          <div slot="extra_action">
            <a-button
              type="primary"
              slot="extra"
              icon="plus"
              @click="handleCreate"
            >
              Create
            </a-button>
          </div>
          <a-button-group
            slot="actions"
            slot-scope="item"
          >
            <template>
              <a-button icon="edit" type="danger" @click="handleEdit(item.source)"
                >Revisi</a-button
              >
            </template>
          </a-button-group>
        </DataListSlot>
      </a-col>
    </a-row>
    <a-modal
      v-if="modalcreateedit"
      v-model="modalcreateedit"
      :title="(mode=='create'? 'Create' : 'Edit') + ' Customer'"
      @ok="processCreateEdit"
      :footer="null"
      @cancel="cancelCreateEdit"
    >
      <a-form :form="modalForm">
        <a-form-item label="Kode">
          <a-input autocomplete="off" v-decorator="['kode', { rules: [{ required: true }], initialValue: (dataSelected ? dataSelected.kode : null) }]"></a-input>
        </a-form-item>
        <a-form-item label="Name" required>
          <a-textarea
            :rows="3" placeholder="Write the Name here ... "
            v-decorator="['nama',{ rules: [{ required: true }], initialValue: (dataSelected ? dataSelected.title : null) },]"
          />
        </a-form-item>
        <a-form-item label="Address" required>
          <a-textarea
            :rows="3" placeholder="Write the Address here ... "
            v-decorator="['alamat',{ rules: [{ required: true }], initialValue: (dataSelected ? dataSelected.subdesc[0] : null) },]"
          />
        </a-form-item>
        <a-form-item label="Sector">
          <a-auto-complete
            autocomplete="off"
            v-decorator="['bidang', { rules: [{ required: true }], initialValue: (dataSelected ? dataSelected.subdesc[1] : null) }]"
            class="certain-category-search"
            dropdownClassName="certain-category-search-dropdown"
            :dropdownMatchSelectWidth="false"
            optionLabelProp="value"
          >
            <template #dataSource>
              <a-select-option v-for="cust in bidangNameList" :key="cust.customer_id" :value="cust.customer_nm.trim()">
                {{ cust.customer_code }} {{ cust.customer_nm }}
              </a-select-option>
            </template>
          </a-auto-complete>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button @click="processCreateEdit" :loading="loading.save" block type="primary" html-type="submit">{{mode=='create' ? 'Save' : 'Save Change' }}</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";

export default {
  name: "SalesContract",
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    return {
      rawData: [],
      sector: null,
      quickSearch: "",
      canCreate: false,
      filtersectorlist: [],
      modalcreateedit: false,
      mode: null,
      bidangNameList: null,
      loading: {
        page: false,
        save: false,
      },
      dataSelected: null,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    datasource() {
      let outputData = this.rawData;

      if (this.quickSearch) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.quickSearch &&
            obj.quickSearch
              .toLowerCase()
              .indexOf(this.quickSearch.toLowerCase()) >= 0
        );
      }

      if (this.sector) {
        outputData = _.filter(outputData, (obj) => obj.subdesc[1] == this.sector);
      }

      return outputData;
    },
  },
  beforeCreate() {
    this.modalForm = this.$form.createForm(this);
  },
  mounted() {
    this.fetch();
  },
  methods: {
    moment,
    async fetch() {      
      this.loading.page = true;
      await this.asyncAxiosGet("customer", this.getAuth, null)
        .then((res) => {
          this.rawData = [];
          res.data.forEach((data) => {
            this.rawData.push({
              kode: data.customer_code,
              title: data.customer_nm,
              subtitle: data.customer_code+" | "+moment(data.last_update).format(this.getDefaultDateFormat)+" - "+data.tlc_update,
              subdesc: [
                data.alamat,
                data.bidang,
              ],
              id: data.customer_id,
              quickSearch:
                data.customer_nm +
                " " +
                data.alamat +
                " " +
                data.bidang +
                " | "+moment(data.last_update).format(this.getDefaultDateFormat)+" - "+data.tlc_update
            });
          });
          this.filtersectorlist = res.nama_bidang;
          this.loading.page = false;
        });
    },
    handleCreate(){
      this.dataSelected=null;
      this.mode = "create";
      this.modalcreateedit = true;
    },
    handleEdit(item){
      this.dataSelected=item;
      this.mode = "edit";
      this.modalcreateedit = true;
    },
    processCreateEdit(){
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let data = new FormData();
        if(this.mode == "edit")
          data.append("id_customer", this.dataSelected.id);
        data.append("nama", values.nama);
        data.append("kode", values.kode);
        data.append("alamat", values.alamat);
        data.append("bidang", values.bidang);

        this.loading.save = true;
        this.asyncAxiosPost(
          this.mode=="create" ? "customer" : "customer/edit",
          "formdata",
          this.getAuth,
          data
        )
        .then((response) => {
          this.displayMessageValue("success-other", response.message);
          this.loading.save = false;
          this.mode = null;
          this.modalcreateedit = false;
          this.fetch();
        })
        .catch((err) => {
          this.loading.save = false;
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
      })
    },
    cancelCreateEdit(){
      this.modalcreateedit = false;
    }
  },
};
</script>

<style></style>
